import { BiConformedKey } from '@euler/model/bi/catalog';
import { BiDatasetColumnRole } from '@euler/model/bi/dataset';
import { BiFieldType } from '@euler/model/bi/result';
import { BiUploadSheetBlock, kBiCsvSheetName } from '@euler/model/bi/upload';

export const kBiFieldTypeLabels: Record<BiFieldType, string> = {
  [BiFieldType.String]: '文本',
  [BiFieldType.Number]: '数字',
  [BiFieldType.Date]: '日期',
  [BiFieldType.Datetime]: '日期时间',
  [BiFieldType.Boolean]: '是 / 否',
};

export const kBiColumnRoleLabels: Record<BiDatasetColumnRole, string> = {
  [BiDatasetColumnRole.Dimension]: '分类',
  [BiDatasetColumnRole.Measure]: '数值',
  [BiDatasetColumnRole.Time]: '时间',
};

export const kBiConformedKeyLabels: Record<BiConformedKey, string> = {
  [BiConformedKey.Date]: '日期',
  [BiConformedKey.Store]: '门店',
  [BiConformedKey.LicensePlate]: '车牌',
  [BiConformedKey.Vin]: '车架号',
  [BiConformedKey.CustomerPhone]: '客户手机号',
  [BiConformedKey.ServiceItemCategory]: '服务项目类别',
  [BiConformedKey.Technician]: '技师',
  [BiConformedKey.ServiceAgent]: '服务顾问',
};

/** Why a sheet cannot be chosen, in words. */
export function biSheetBlockText(
  block: BiUploadSheetBlock,
  rowLimit: number | null,
): string {
  switch (block) {
    case BiUploadSheetBlock.RowLimit:
      return rowLimit
        ? `超过 ${rowLimit.toLocaleString('zh-CN')} 行上限`
        : '行数超过上限';
    case BiUploadSheetBlock.Empty:
      return '没有数据';
    case BiUploadSheetBlock.Unreadable:
      return '无法读取';
  }
}

/** A sheet's name as shown; a CSV's only sheet has none worth showing. */
export function biSheetTitle(sheet: string, fileName: string): string {
  return sheet === kBiCsvSheetName || !sheet ? fileName : sheet;
}

export function biRowsColumns(rows: number, columns: number): string {
  return `${rows.toLocaleString('zh-CN')} 行 · ${columns} 列`;
}
